var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardImage6Min(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 250,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M135.465 239.19c26.598-4.268 53.591 2.252 80.309 5.782 26.719 3.53 56.16 3.41 77.856-11.854 25.526-17.968 32.681-51.501 32.01-81.744-.751-35.009-10.36-71.591-36.058-96.626-13.703-13.346-31.099-22.603-48.299-31.533C219.776 12.034 197.163.803 172.687.038c-21.397-.564-42.169 6.917-57.828 20.827-12.195 10.93-20.475 25.171-30.646 37.856-18.783 23.423-44.676 42.49-56.102 69.88-10.401 24.926-6.594 54.786 9.798 76.586 16.392 21.8 44.796 34.877 72.896 33.533",
    fill: "#F7941D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m110.799 216.106 152.099 19.647c2.712.35 5.461-.316 7.668-1.86 2.206-1.543 3.698-3.843 4.161-6.414l11.713-64.896a9.615 9.615 0 0 0-.124-3.996 9.89 9.89 0 0 0-1.745-3.636 10.417 10.417 0 0 0-3.091-2.702 10.888 10.888 0 0 0-3.95-1.345l-138.178-18.947a11 11 0 0 0-6.866 1.287c-2.069 1.16-3.661 2.958-4.515 5.096l-25.611 64.202a9.633 9.633 0 0 0-.654 4.448 9.739 9.739 0 0 0 1.44 4.276 10.3 10.3 0 0 0 3.246 3.254 10.877 10.877 0 0 0 4.407 1.586z",
    fill: "#F7941D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m110.799 216.106 152.099 19.647c2.712.35 5.461-.316 7.668-1.86 2.206-1.543 3.698-3.843 4.161-6.414l11.713-64.896a9.615 9.615 0 0 0-.124-3.996 9.89 9.89 0 0 0-1.745-3.636 10.417 10.417 0 0 0-3.091-2.702 10.888 10.888 0 0 0-3.95-1.345l-138.178-18.947a11 11 0 0 0-6.866 1.287c-2.069 1.16-3.661 2.958-4.515 5.096l-25.611 64.202a9.633 9.633 0 0 0-.654 4.448 9.739 9.739 0 0 0 1.44 4.276 10.3 10.3 0 0 0 3.246 3.254 10.877 10.877 0 0 0 4.407 1.586z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m139.14 127.099 141.423 19.346a9.136 9.136 0 0 0 6.388-1.486c1.849-1.263 3.112-3.159 3.526-5.291l17.922-93.658a8 8 0 0 0-.085-3.399 8.216 8.216 0 0 0-1.492-3.087 8.678 8.678 0 0 0-2.655-2.27 9.102 9.102 0 0 0-3.382-1.081l-155.51-17.827a9.22 9.22 0 0 0-3.595.298 8.938 8.938 0 0 0-3.167 1.647 8.445 8.445 0 0 0-2.209 2.72 8.066 8.066 0 0 0-.879 3.336l-3.824 92.128c-.082 2.071.643 4.098 2.035 5.69 1.392 1.592 3.352 2.637 5.504 2.934z",
    fill: "#F7941D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m143.716 126.825 131.796 18.035a8.521 8.521 0 0 0 5.963-1.393c1.723-1.182 2.899-2.955 3.279-4.947l16.702-87.28a7.462 7.462 0 0 0-.075-3.17 7.665 7.665 0 0 0-1.389-2.88 8.09 8.09 0 0 0-2.475-2.118 8.482 8.482 0 0 0-3.153-1.008L149.432 25.45a8.597 8.597 0 0 0-3.349.281 8.343 8.343 0 0 0-2.95 1.537 7.895 7.895 0 0 0-2.056 2.534 7.53 7.53 0 0 0-.819 3.108l-3.572 85.844c-.085 1.936.587 3.833 1.886 5.324 1.298 1.491 3.131 2.47 5.144 2.747z",
    fill: "#F7941D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m143.716 126.825 131.796 18.035a8.521 8.521 0 0 0 5.963-1.393c1.723-1.182 2.899-2.955 3.279-4.947l16.702-87.28a7.462 7.462 0 0 0-.075-3.17 7.665 7.665 0 0 0-1.389-2.88 8.09 8.09 0 0 0-2.475-2.118 8.482 8.482 0 0 0-3.153-1.008L149.432 25.45a8.597 8.597 0 0 0-3.349.281 8.343 8.343 0 0 0-2.95 1.537 7.895 7.895 0 0 0-2.056 2.534 7.53 7.53 0 0 0-.819 3.108l-3.572 85.844c-.085 1.936.587 3.833 1.886 5.324 1.298 1.491 3.131 2.47 5.144 2.747z",
    fill: "url(#b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m177.108 64.066 6.083-5.257 10.039 1.612-2.545 10.788-17.539-2.427 3.962-4.716z",
    fill: "#F7941D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m177.108 64.066 6.083-5.257 10.039 1.612-2.545 10.788-17.539-2.427 3.962-4.716z",
    fill: "url(#c)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m188.896 64.558 10.326.404.986 7.416-15.985-2.022 4.673-5.798z",
    fill: "#F7941D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m188.896 64.558 10.326.404.986 7.416-15.985-2.022 4.673-5.798z",
    fill: "url(#d)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m196.344 61.098-5.659 10.11 15.704 1.487-.281-10.925-9.764-.672z",
    fill: "#F7941D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m196.344 61.098-5.659 10.11 15.704 1.487-.281-10.925-9.764-.672z",
    fill: "url(#e)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m161.639 67.793-.568-10.963 18.296.175 1.324 13.488-19.052-2.7z",
    fill: "#F7941D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m161.639 67.793-.568-10.963 18.296.175 1.324 13.488-19.052-2.7z",
    fill: "url(#f)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m111.648 209.904 152.116 19.674c2.712.35 5.461-.317 7.668-1.86 2.206-1.543 3.698-3.843 4.16-6.414l11.714-64.897a9.617 9.617 0 0 0-.115-4.007 9.844 9.844 0 0 0-1.747-3.646 10.408 10.408 0 0 0-3.101-2.708 10.916 10.916 0 0 0-3.964-1.339l-138.178-18.953a10.998 10.998 0 0 0-6.866 1.287c-2.069 1.161-3.662 2.958-4.515 5.096l-25.629 64.203a9.642 9.642 0 0 0-.652 4.45 9.752 9.752 0 0 0 1.444 4.279 10.297 10.297 0 0 0 3.252 3.253 10.897 10.897 0 0 0 4.413 1.582z",
    fill: "#F7941D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m255.76 202.089-124.526-15.368c-7.483-1.043-12.041-7.727-10.143-14.924l11.57-27.019c1.881-7.197 9.472-12.187 16.96-11.138l116.826 16.33c7.483 1.043 12.041 7.727 10.143 14.924l-3.87 26.057c-1.881 7.192-9.478 12.187-16.96 11.138z",
    fill: "url(#g)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M159.529 209.969c-.608 2.153-1.273 4.399-2.867 6.012-3.245 3.218-8.727 2.574-13.319 1.688-1.101-.213-2.259-.448-3.108-1.153a5.473 5.473 0 0 1-1.502-2.465c-3.44-9.585.224-20.176 5.292-29.079 1.8-3.158 3.813-6.262 6.565-8.716 4.122-3.678 9.586-5.618 14.907-7.471-5.006 4.432-9.027 9.778-11.826 15.719a46.75 46.75 0 0 0-4.463 18.869c0 1.044 8.79-4.536 9.323-4.569 4.902-.311 1.737 8.558.998 11.165z",
    fill: "url(#h)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M224.254 211.21c2.208-5.361 4.461-11.056 3.44-16.734-.751-4.164-3.228-7.995-3.44-12.22-.114-2.453.574-4.956 0-7.35-1.146-4.815-6.731-7.345-9.443-11.558-.831-1.285-1.313-3.11-.2-4.181.802-.782 2.092-.809 3.233-.76a89.016 89.016 0 0 1 29.671 6.449c4.22 1.716 8.497 3.929 10.894 7.651 2.397 3.721 2.523 8.394 2.46 12.788a259.993 259.993 0 0 1-4.071 41.982 3.474 3.474 0 0 1-.717 1.836c-.9.956-2.5.738-3.813.437-8.48-1.935-13.858-2.186-22.36-4.093-2.569-.59-9.1-.672-11.318-1.798 1.009-3.541 4.174-8.859 5.664-12.449z",
    fill: "url(#i)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M256.66 147.909c-4.013-1.841-9.116-2.186-12.757.29-2.999 2.022-4.489 5.503-5.418 8.886-1.388 5.05-1.841 10.444-.344 15.46 1.496 5.017 5.16 9.597 10.251 11.515 5.092 1.918 11.542.7 14.845-3.459 2.66-3.345 2.975-7.815 3.193-12.023.184-3.613 1.795-9.996.075-13.116-1.652-3.017-6.749-6.077-9.845-7.553z",
    fill: "#F3A984"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M256.66 147.909c-4.013-1.841-9.116-2.186-12.757.29-2.999 2.022-4.489 5.503-5.418 8.886-1.388 5.05-1.841 10.444-.344 15.46 1.496 5.017 5.16 9.597 10.251 11.515 5.092 1.918 11.542.7 14.845-3.459 2.66-3.345 2.975-7.815 3.193-12.023.184-3.613 1.795-9.996.075-13.116-1.652-3.017-6.749-6.077-9.845-7.553z",
    fill: "url(#j)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m258.622 127.497-40.351-18.942c-2.344-1.1-5.179-.181-6.333 2.053l-11.319 21.905c-1.154 2.234-.19 4.937 2.154 6.037l40.351 18.942c2.344 1.1 5.179.181 6.333-2.053l11.319-21.905c1.154-2.234.19-4.936-2.154-6.037z",
    fill: "#F7941D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m259.191 128.359-40.43-18.839c-2.3-1.072-5.076-.164-6.2 2.028l-10.757 20.973c-1.124 2.192-.171 4.838 2.128 5.909l40.43 18.84c2.3 1.072 5.076.164 6.2-2.028l10.757-20.973c1.125-2.192.172-4.838-2.128-5.91z",
    fill: "url(#k)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M236.96 153.33c-2.44-2.8-5.792-4.741-9.524-5.514a6.962 6.962 0 0 0-3.09-.066 3.1 3.1 0 0 0-1.366.681c-.387.335-.677.76-.841 1.232a3.79 3.79 0 0 0 .321 2.367c1.961 5.082 6.221 9.148 8.061 14.269 1.537 4.279 3.905 7.596 4.088 12.11.229 5.847-1.33 11.755-.195 17.488.791 4.006 2.867 7.755 3.228 11.815.241 2.7-.229 5.662 1.33 7.93 1.938 2.82 6.026 3.229 9.558 3.355 3.125.115 6.582.126 8.962-1.814 1.387-1.126 2.19-2.76 2.947-4.339l14.391-29.905c.82-1.705 1.657-3.492 1.559-5.366-.143-2.618-2.047-4.788-3.216-7.159-3.842-7.761.378-16.942-.717-25.462-.929-7.219-5.625-13.482-10.819-18.81-1.239-1.273-2.924-2.629-4.673-2.142-2.23.623-2.46 3.689-1.365 5.64 1.096 1.951 3.011 3.453 3.785 5.541.573 1.612.43 3.377.263 5.082l-1.146 11.564c-.299 3.011-.574 6.012-1.113 9.017-.619 3.58-2.121 7.706-5.791 8.662-2.866.755-5.939-.918-7.751-3.18-1.812-2.263-2.724-5.05-3.928-7.651-1.204-2.601-1.06-3.159-2.958-5.345z",
    fill: "#F3A984"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M247.366 209.996c-2.574-.448-5.16-1.136-7.775-.967-2.614.17-5.36 1.443-6.306 3.771-.396.956-.453 2.011-.792 2.984-.498 1.443-1.576 2.629-2.293 3.973-1.204 2.186-1.496 4.683-1.772 7.132l-2.15 19.127c13.52 4.656 29.287 6.137 41.769-.661a5.156 5.156 0 0 0 2.093-1.738c.527-.913.447-2.022.349-3.055-.837-9.192-.745-19.002-2.551-28.057-1.043-5.214-3.056-3.115-7.826-2.35-4.438.721-8.4-.159-12.746-.159z",
    fill: "#F7941D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m215.14 121.406 3.1 1.42c1.409.645 2.492 1.797 3.01 3.203a5.38 5.38 0 0 1-.249 4.293l-.166.33a2.39 2.39 0 0 1-1.383 1.181 2.534 2.534 0 0 1-1.854-.098l-6.227-2.852a2.421 2.421 0 0 1-.757-.541 2.285 2.285 0 0 1-.481-.777 2.212 2.212 0 0 1 .102-1.766l1.668-3.311a2.33 2.33 0 0 1 .569-.721 2.47 2.47 0 0 1 .814-.459 2.523 2.523 0 0 1 1.854.098z",
    fill: "url(#l)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m219.599 136.526-2.265-1.033-1.725 3.436 2.266 1.033 1.724-3.436z",
    fill: "url(#m)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m222.964 138.145-2.266-1.033-1.724 3.437 2.266 1.032 1.724-3.436z",
    fill: "url(#n)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m226.328 139.765-2.265-1.033-1.724 3.436 2.265 1.033 1.724-3.436z",
    fill: "url(#o)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m229.699 141.378-2.266-1.032-1.724 3.436 2.266 1.033 1.724-3.437z",
    fill: "url(#p)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m233.061 143.002-2.265-1.032-1.725 3.436 2.266 1.033 1.724-3.437z",
    fill: "url(#q)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m236.426 144.622-2.266-1.033-1.724 3.436 2.266 1.033 1.724-3.436z",
    fill: "url(#r)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m239.79 146.241-2.265-1.033-1.724 3.436 2.265 1.033 1.724-3.436z",
    fill: "url(#s)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m243.161 147.855-2.266-1.033-1.724 3.436 2.266 1.033 1.724-3.436z",
    fill: "url(#t)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m246.525 149.474-2.265-1.033-1.724 3.437 2.265 1.032 1.724-3.436z",
    fill: "url(#u)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M162.057 198.515c.165-.405.211-.846.132-1.274a1.933 1.933 0 0 0-.929-1.033c-2.614-1.579-6.163-.366-8.485 1.58-2.323 1.945-4.014 4.557-6.416 6.388-1.411-4.47.699-9.186 2.763-13.422 3.761-7.716 8.027-15.941 15.836-20.029.952-.492 2.047-1.027 2.34-2.022.504-1.683-1.675-3.006-3.509-3.066-2.73-.093-5.321 1.132-8.027 1.356-2.294.185-4.587-.339-6.881-.312a28.56 28.56 0 0 0-6.025.935c-4.656 1.065-9.455 2.186-13.279 4.918-2.615 1.875-4.627 4.405-6.485 6.973-2.815 3.886-5.401 7.996-6.771 12.532-2.506 8.284-.855 17.602-4.914 25.308-1.439 2.732-3.623 5.58-2.758 8.52.683 2.328 3.096 3.781 5.424 4.743a34.617 34.617 0 0 0 15.383 2.52 8.838 8.838 0 0 0 2.781-.547 9.747 9.747 0 0 0 2.425-1.639c11.335-9.411 23.525-17.685 27.395-32.429z",
    fill: "#F3A984"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m193.523 217.68-25.05-3.333c-2.867-.383-4.501-2.733-3.647-5.258l3.205-9.416c.855-2.525 3.876-4.257 6.749-3.874l25.05 3.333c2.866.383 4.5 2.733 3.64 5.257l-3.199 9.417c-.843 2.524-3.882 4.257-6.748 3.874z",
    fill: "url(#v)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M92.98 236.627c6.45 2.416 12.952 4.848 19.757 6.094 6.806 1.246 14.019 1.246 20.492-1.121 1.336-.486 2.792-1.251 3.09-2.585.212-.945-.229-1.901-.665-2.781l-2.064-4.165a2.663 2.663 0 0 0-1.009-1.347 2.876 2.876 0 0 0-1.651-.516c-4.203-.7-8.52-1.131-12.453-2.733-6.56-2.634-6.978-9.607-14.197-5.394-1.582.946-12.768 13.996-11.3 14.548zM210.104 111.485l-60.735-7.202 9.064-36.665 9.088.924 2.047.207 26.305 2.684 2.053.207 9.925 1.017 2.253 38.828z",
    fill: "#F7941D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M195.759 46.474c-3.561-4.41-9.025-6.361-15.395-5.52a13.037 13.037 0 0 0-4.92 1.604 12.411 12.411 0 0 0-3.823 3.359c-5.126 6.607-4.587 17.816-4.1 22.625l2.047.207c-.482-4.328-1.147-15.498 3.658-21.701a10.663 10.663 0 0 1 3.252-2.833 11.206 11.206 0 0 1 4.167-1.364c5.688-.765 10.366.902 13.526 4.787 4.46 5.52 5.062 14.674 1.72 23.795l2.046.207c3.406-9.574 2.621-19.23-2.178-25.166z",
    fill: "#F7941D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m210.104 111.485-60.735-7.202 9.064-36.665 9.088.924 2.047.207 26.305 2.684 2.053.207 9.925 1.017 2.253 38.828z",
    fill: "#F7941D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M195.759 46.474c-3.561-4.41-9.025-6.361-15.395-5.52a13.037 13.037 0 0 0-4.92 1.604 12.411 12.411 0 0 0-3.823 3.359c-5.126 6.607-4.587 17.816-4.1 22.625l2.047.207c-.482-4.328-1.147-15.498 3.658-21.701a10.663 10.663 0 0 1 3.252-2.833 11.206 11.206 0 0 1 4.167-1.364c5.688-.765 10.366.902 13.526 4.787 4.46 5.52 5.062 14.674 1.72 23.795l2.046.207c3.406-9.574 2.621-19.23-2.178-25.166z",
    fill: "#F7941D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m283.765 61.062-50.457-5.36c-2.839-.302-5.397 1.647-5.713 4.352l-.066.565c-.317 2.706 1.728 5.144 4.567 5.445l50.458 5.36c2.838.302 5.396-1.646 5.712-4.352l.066-.565c.317-2.706-1.728-5.143-4.567-5.445z",
    fill: "url(#w)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m282.348 75.361-50.458-5.36c-2.839-.302-5.396 1.647-5.713 4.353l-.066.564c-.316 2.706 1.728 5.144 4.567 5.446l50.458 5.36c2.839.302 5.396-1.647 5.713-4.353l.066-.565c.316-2.705-1.729-5.143-4.567-5.445z",
    fill: "url(#x)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m280.936 89.65-50.458-5.36c-2.838-.302-5.396 1.647-5.712 4.353l-.066.565c-.317 2.705 1.728 5.143 4.567 5.445l50.458 5.36c2.838.302 5.396-1.647 5.712-4.353l.066-.564c.317-2.706-1.728-5.144-4.567-5.446z",
    fill: "url(#y)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 145.782,
    y1: 46.314,
    x2: 416.1,
    y2: 483.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 193.081,
    y1: 164.976,
    x2: 203.366,
    y2: 365.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 184.636,
    y1: 61.301,
    x2: 179.025,
    y2: 81.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 190.134,
    y1: 65.017,
    x2: 199.077,
    y2: 81.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 196.51,
    y1: 62.951,
    x2: 214.85,
    y2: 100.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 173.616,
    y1: 58.885,
    x2: 160.138,
    y2: 84.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 213.372,
    y1: 132.045,
    x2: 158.325,
    y2: 313.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 134.444,
    y1: 219.265,
    x2: 217.793,
    y2: 107.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 232.728,
    y1: 163.91,
    x2: 253.35,
    y2: 287.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 242.395,
    y1: 151.199,
    x2: 271.002,
    y2: 194.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 217.806,
    y1: 110.411,
    x2: 283.253,
    y2: 239.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 222.05,
    y1: 119.381,
    x2: 211.531,
    y2: 134.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 236.639,
    y1: -30.123,
    x2: 195.37,
    y2: 187.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 147.205,
    y1: 45.433,
    x2: 417.523,
    y2: 482.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 148.629,
    y1: 44.56,
    x2: 418.937,
    y2: 482.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 150.062,
    y1: 43.676,
    x2: 420.37,
    y2: 481.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 151.477,
    y1: 42.792,
    x2: 421.791,
    y2: 480.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 152.901,
    y1: 41.919,
    x2: 423.219,
    y2: 479.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 154.328,
    y1: 41.04,
    x2: 424.64,
    y2: 478.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 155.754,
    y1: 40.159,
    x2: 426.066,
    y2: 477.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 157.174,
    y1: 39.278,
    x2: 427.492,
    y2: 476.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 185.091,
    y1: 197.647,
    x2: 185.798,
    y2: 234.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 264.487,
    y1: 43.876,
    x2: 252.997,
    y2: 81.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 263.07,
    y1: 58.17,
    x2: 251.585,
    y2: 96.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 261.658,
    y1: 72.464,
    x2: 250.168,
    y2: 110.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImage6Min);
export default __webpack_public_path__ + "static/media/Card Image 6-min.fb18681ce0c840662dbd5c88828c0878.svg";
export { ForwardRef as ReactComponent };